import { Fragment, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../ReduxToolkit/Hooks";
import { setLayoutType } from "../../ReduxToolkit/Reducers/TemplateCustomizerReducers";
import ChatWallpaper from "./ChatWallpaper";
import ColorChoose from "./ColorChoose";
import SettingSidebar from "./SettingSidebar";
import SidebarSetting from "./SidebarSetting";
import TemplateLayout from "./TemplateLayout";

const TemplateCustomizer = () => {
  const dispatch = useAppDispatch();
  const { layoutType } = useAppSelector((state) => state.templateCustomizer);
  const [customizer, setCustomizer] = useState(false);
  const toggleCustomizer = () => setCustomizer(!customizer);

  return (
    <Fragment>
      <div className="sidebar-pannle-main">
        <ul>
          <li className="rtl-setting icon-btn btn-primary" onClick={() => dispatch(setLayoutType())}>
            {layoutType ? "RTL" : "LTR"}
          </li>
          <li className="cog-click icon-btn btn-success" onClick={toggleCustomizer}>
            <i className="fa fa-cog"></i>
          </li>
        </ul>
      </div>
      <section className="setting-sidebar" style={customizer ? { right: "0px" } : { right: "-400px" }}>
        <SettingSidebar setCustomizer={toggleCustomizer} />
        <ColorChoose />
        <TemplateLayout />
        <div className="chat-wallpaper">
          <ChatWallpaper />
          <SidebarSetting />
        </div>
      </section>
    </Fragment>
  );
};

export default TemplateCustomizer;
